import {Component, OnDestroy, OnInit} from '@angular/core';
import {Constants} from '../shared/Helpers/constants';
import {SharedService} from '../shared/shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HelperFunctions} from '../shared/Helpers/helperFunctions';
import {AuthenticationService, UserService} from '../_services';
import {Subject} from 'rxjs/internal/Subject';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {AbleExpiryPasswordSettings, IOAuth2ConfigurationSimpleDto, ISimpleOrganisation} from '../shared/interfaces';
import {Alert, AlertTypeEnum} from '../shared/Helpers/Alert';
import {CookieService} from 'ngx-cookie';
import {environment} from '@env/environment';
import * as moment from 'moment/moment';
import {Buffer} from 'buffer';
import {UserContext} from '../_context/user.context';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {Observable} from 'rxjs/internal/Observable';
import { AbleBaseLoginComponent } from '../login/base-login.component';
import { AuthXService } from '@authx/authx-workflow-lib';
import { FederatedAuthenticationService } from '../_services/federated-authentication.service';

@Component({
  selector: "able-oauth2-login",
  templateUrl: "./oauth2-login.component.html",
  styleUrls: [
    "../login/login.component.css"
  ]
})
export class Oauth2LoginComponent extends AbleBaseLoginComponent implements OnInit, OnDestroy{
  private triggerGetPeople: BehaviorSubject<any> = new BehaviorSubject<any>(undefined)
  public triggerGetPeople$: Observable<any> = this.triggerGetPeople.asObservable()

  public logoPath: string = Constants.logoPath;
  public passwordInputType: 'text' | 'password' = 'password';
  public passwordMode: boolean = true;
  public passwordExpirySettings: AbleExpiryPasswordSettings = {}
  public encodedAuthorizationUrl: string;
  private resourceId: string;
  constructor(
    protected sharedService: SharedService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected userService: UserService,
    protected userContext: UserContext,
    protected authenticationService: AuthenticationService,
    protected cookieService: CookieService,
    protected authXService: AuthXService,
    protected federatedAuthService: FederatedAuthenticationService
  ) {
    super(
      router,
      sharedService,
      authenticationService,
      cookieService,
      userContext,
      authXService,
      userService,
      federatedAuthService
    )
    this.userContext = new UserContext()
    this.getQueryParams();
  }
  ngOnInit() {
  }
  ngOnDestroy() {
    this._destroySubscription$.complete()
    this._destroySubscription$.unsubscribe()
  }

  public getQueryParams = () => {
    this.encodedAuthorizationUrl = this.activatedRoute.snapshot.queryParams?.authorizationUrl;
    this.organisationId = this.activatedRoute.snapshot.queryParams?.organisationId;
    this.resourceId = this.activatedRoute.snapshot.queryParams?.resourceId;
    if (!this.encodedAuthorizationUrl){
      this.router.navigateByUrl("login");
      return
    }else {
      localStorage.setItem('authorizationUrl', this.encodedAuthorizationUrl);
    }
    this.checkLoginProviders();

  }

  private checkLoginProviders = () => {
    this.handleOauth2ProvidersLogin(this.organisationId, this.resourceId)
      .pipe(takeUntil(this._destroySubscription$))
      .subscribe({
        next: (res: IOAuth2ConfigurationSimpleDto[]) => {
          this.afterProvidersCheck()
        },
        error: (err) => {
          this.afterProvidersCheck()
        }
      })
  }

  public afterProvidersCheck = () => {
          this.initLastUsersAccess()
          this.checkIfUserIsAuthenticated()
          const organisationIds: string[] = [];
          if (this.organisationId) {
            this.sharedService.changeCurrentOrganisationId(this.organisationId)
            organisationIds.push(this.organisationId)
          }
          this.searchInput$.next({
            searchString: '',
            pageSize: 10,
            organisationIds: organisationIds
          })
  }

  public handleLoginEvents = (isValid: boolean) => {
    if (isValid) { //Keycode for enter
      if (this.userNameValidated) {
        this.onUserLogin()
      }else this.usernameValidation()
    }
  }
  public changePasswordMode = (isPassword: boolean) => {
    this.passwordMode = isPassword;
    this.passwordInputType = (isPassword ? 'password' : 'text')
  }

  public onRemove = (isOrganisation: boolean = false) => {
    if (isOrganisation) {
      this.organisationId = undefined;
      this.sharedService.changeCurrentOrganisationId(undefined);
      this.loginModel.organisation = undefined;
      this.selectedOrganisationName = undefined
    }
    this.userNameValidated = undefined;
    this.loginModel.username = undefined;
    this.loginModel.password = undefined;
  }

  protected checkIfSamlRequestExistsInLocalStorage = () => {
    this.handleOauth2Redirect()
  }

  protected getPeopleData = () => {
    this.triggerGetPeople.next(new Date())
  }

  public handleOauth2Redirect = () => {
    const user = new UserContext()
    const authenticationUrl = `${Buffer.from(this.encodedAuthorizationUrl, 'base64').toString('utf-8')}&token=${user.token}`;
    window.location.replace(authenticationUrl)
  }


}
